module.exports = __webpack_public_path__ + "img/рз_24.7cc70057.png";